import { setAspectRatioHeight } from "./campaigns/aspectRatioCalc";

type fireDynamicChangesT = () => void;
export const fireDynamicChanges: fireDynamicChangesT = () => {
  setAspectRatioHeight();
};
